export default __webpack_public_path__ + "static/media/c-map.f5019bff.png";